// @flow

import { FaArrowAltCircleDown, FaArrowAltCircleRight, FaArrowAltCircleUp, FaCircle } from "react-icons/fa";
import { useEffect, useState } from "react";
import { ModelCardComponentMC } from "./ModelCardComponentMC";
import ModelDataService from "../axios/services/ModelDataService";

import SubmissionExerciseDataService from "../axios/services/SubmissionExerciseDataService";
//import Tooltip from "../tooltip";
import { emptyAssessment } from "../types/Assessment";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { b64DecodeUnicode } from "./b64";
import MDEditor from "@uiw/react-md-editor";

const dateOptions = {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
} as any;

type Props = {
  UI: string;
};

export const FeedbackCardMC = (props: Props): any => {
  let { submissionExerciseId, exerciseId } = useParams();
  // TODO: remove, im aufruf unten auch
  //let userId = localStorage.getItem("unique-token");
  const { t, i18n } = useTranslation();
  const [assessment, setAssessment] = useState(emptyAssessment) as any;
  const navigate = useNavigate();
  const [submission_exercise, setSubmission_exercise] = useState({}) as any;
  const [feedbacks, setFeedbacks] = useState([]);
  const [modelId, setModelId] = useState(-1);
  // Cell ids of the shown model; undefined until it arrived. Anchored messages are listed
  // either way, but only those whose element is missing carry the hint that says so.
  const [modelCellIds, setModelCellIds] = useState<any>(undefined);
  const [description, setDescription] = useState("");
  const [scenario, setScenario] = useState("");
  const [categoryMap, setCategoryMap] = useState({}) as any;
  const [submissionFlag, setSubmissionFlag] = useState(false);
  const [feedForwardThreshold, setFeedForwardThreshold] = useState(-1);
  const [feedForwardPos, setFeedForwardPos] = useState("");
  const [feedForwardNeg, setfeedForwardNeg] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_manual, setManualFeedbacks] = useState([]);
  const [ohneBewertung, setOhneBewertung] = useState(false);

  useEffect(() => {
    SubmissionExerciseDataService.get(submissionExerciseId, props.UI)
      .then((response: any) => {
        let assessment = response.data.data;

        // Without a completed assessment the server sends a message instead of these fields.
        if (!Array.isArray(assessment.feedbacksmanual) || !Array.isArray(assessment.gradings)) {
          setOhneBewertung(true);
          return;
        }

        setAssessment(assessment);

        var Feedbacks = [] as any;
        for (var o = 0; o < assessment.feedbacksmanual.length; o++) {
          let manual = assessment.feedbacksmanual[o];
          Feedbacks.push(manual);
        }

        for (var i = 0; i < assessment.gradings.length; i++) {
          let grading = assessment.gradings[i];

          for (var a = 0; a < (grading.feedbacks || []).length; a++) {
            let feedback = grading.feedbacks[a];

            Feedbacks.push(feedback);
          }
        }

        setFeedbacks(Feedbacks);
        setManualFeedbacks(Feedbacks);
      })
      .catch((e: any) => {
        console.log(e);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    SubmissionExerciseDataService.getSubmissionExercise(submissionExerciseId, props.UI)
      .then((response: any) => {
        let submissionExercise = response.data.data;
        setSubmission_exercise(submissionExercise);
        setSubmissionFlag(true);
        setDescription(b64DecodeUnicode(submissionExercise.exercise.description) as string);
        setScenario(b64DecodeUnicode(submissionExercise.exercise.creation.scenario) as string);
        setFeedForwardThreshold(submissionExercise.exercise.feedForward_threshold);
        setFeedForwardPos(submissionExercise.exercise.feedForward_pos);
        setfeedForwardNeg(submissionExercise.exercise.feedForward_neg);
      })
      .catch((e: any) => {
        console.log(e);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Running number per message, by the same rule the correction view uses: sorted by id,
  // so a number means the same thing on both sides. Suppressed messages get none.
  const feedbackNumbers = () => {
    const numbers: Record<string, number> = {};
    [...feedbacks]
      .filter((feedback: any) => !feedback.suppressToUser)
      .sort((a: any, b: any) => a.id - b.id)
      .forEach((feedback: any, index: number) => {
        numbers[(feedback.grader || "") + "#" + feedback.id] = index + 1;
      });
    return numbers;
  };

  // The editor draws these at the anchored elements and asks for them once it has loaded.
  useEffect(() => {
    const sendNumbers = () => {
      const numbers = feedbackNumbers();
      const byElement: Record<string, Array<number>> = {};
      feedbacks.forEach((feedback: any) => {
        const elementId = feedback.positionId;
        if (typeof elementId !== "string" || elementId === "") return;
        const number = numbers[(feedback.grader || "") + "#" + feedback.id];
        if (typeof number !== "number") return;
        byElement[elementId] = [...(byElement[elementId] || []), number];
      });
      Object.keys(byElement).forEach((elementId) => byElement[elementId].sort((a, b) => a - b));
      const frame = document.querySelector("iframe") as HTMLIFrameElement | null;
      frame?.contentWindow?.postMessage({ type: "showNumbers", numbers: byElement }, "*");
    };
    const onMessage = (event: MessageEvent) => {
      if (event.data?.type === "numbersPlease") sendNumbers();
    };
    window.addEventListener("message", onMessage);
    sendNumbers();
    // The editor finishes loading after this ran and only asks again when its own feedback
    // changes, so the first paint needs the numbers sent once the frame is there.
    const frame = document.querySelector("iframe") as HTMLIFrameElement | null;
    frame?.addEventListener("load", sendNumbers);
    return () => {
      window.removeEventListener("message", onMessage);
      frame?.removeEventListener("load", sendNumbers);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedbacks, modelId]);

  useEffect(() => {
    var hashmap = {} as any;
    const numbers = feedbackNumbers();
    for (let i = 0; i < feedbacks.length; i++) {
      var current = feedbacks[i] as any;
      // only add feedback to hashmap if not supressed to user
      if (!current.suppressToUser) {
        var category = current.category;
        var valuation = current.valuation;
        var content = current.content;
        var positionX = current.positionX;
        var positionY = current.positionY;
        var positionID = current.positionId;
        var number = numbers[(current.grader || "") + "#" + current.id];

        if (category in hashmap) {
          if (valuation in hashmap[category]) {
            hashmap[category][valuation].push([content, positionX, positionY, positionID, number]);
          } else {
            hashmap[category][valuation] = [];
            hashmap[category][valuation].push([content, positionX, positionY, positionID, number]);
          }
        } else {
          hashmap[category] = {};
          hashmap[category][valuation] = [];
          hashmap[category][valuation].push([content, positionX, positionY, positionID, number]);
        }
      }
    }
    console.log(hashmap);

    setCategoryMap(hashmap);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedbacks]);

  useEffect(() => {
    if (!submissionFlag) {
      return;
    } else {
    }
    ModelDataService.getModelforSubex(exerciseId, "studentSolution")
      .then((response: any) => {
        let models = response.data.data;
        for (let i = 0; i < models.length; i++) {
          let model = models[i];

          // eslint-disable-next-line eqeqeq
          if (model.parentId === parseInt(submissionExerciseId as string)) {
            setModelId(model.id);
            setModelCellIds((model.graphData?.graph?.cells ?? []).map((cell: any) => cell.id));
            break;
          }
        }
      })
      .catch((e: any) => {
        console.log(e);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionFlag]);

  const getTableItemGrading = (grading: any) => {
    if (grading.resultType === "RELATIVE")
      return (
        <tr key={grading.id}>
          <td>{grading.gradingservice.name}</td>
          {/*
          <th>
            {grading.gradingservice.name}
            <Tooltip
              icon="circle-info"
              class="icon tooltip no-border is-white has-tooltip-multiline has-tooltip-right"
              content={grading.gradingservice.description}
            ></Tooltip>
          </th>
          */}
          <td>{grading.result * 100} % </td>
          <td>{t("RELATIVE")} </td>
          <td>{grading.weight} %</td>
          <th className="has-text-right">
            {parseFloat(((grading.weight / 100) * parseFloat(assessment.maxTotalScore) * grading.result).toFixed(2))} /{" "}
            {parseFloat(((grading.weight / 100) * parseFloat(assessment.maxTotalScore)).toFixed(2))}
          </th>
          <td></td>
        </tr>
      );
    else
      return (
        <tr key={grading.id}>
          <td>{grading.gradingservice.name}</td>
          <td>{grading.result}</td>
          <td>{t("ABSOLUTE")} </td>
          <th className="has-text-right">
            {parseFloat(((grading.weight / 100) * parseFloat(assessment.maxTotalScore) * grading.result).toFixed(2))}/
            {parseFloat(((grading.weight / 100) * parseFloat(assessment.maxTotalScore)).toFixed(2))}
          </th>
          <td></td>
        </tr>
      );
  };

  function back() {
    navigate(-1); // go to previous page
  }

  function sortvaluation(a: any, b: any) {
    return b.length - a.length;
  }

  function getValuationItem(input: any, index: any) {
    var valuations = Object.keys(input);
    valuations.sort(sortvaluation).reverse();

    // The same number the editor draws at the anchored element, so list and model match.
    const numberTag = (value: any) =>
      typeof value === "number" ? <span className="tag is-light mr-2">{value}</span> : null;

    return (
      <div key={index}>
        <div>
          <ul>
            {valuations.map((valuation, index2) => {
              return (
                <div key={index2}>
                  {input[valuation].map((content: any, index3: number) => {
                    const anchorMissing =
                      content[3] !== "" && modelCellIds !== undefined && !modelCellIds.includes(content[3]);
                    if (anchorMissing) {
                      return (
                        <li key={index3} className="no-bulletpoint">
                          {numberTag(content[4])}<FaCircle className="has-text-grey-light" /> &nbsp; {content[0]}{" "}
                          <span className="has-text-grey">({t("feedbackAnchorNotFound")})</span>
                        </li>
                      );
                    }
                    if (valuation === "POSITIVE")
                      return (
                        <li key={index3} className="no-bulletpoint">
                          {" "}
                          {numberTag(content[4])}<FaArrowAltCircleUp className="has-text-success" /> &nbsp; {content[0]}
                          {content[1] !== 0 || content[2] !== 0 ? (
                            // eslint-disable-next-line no-useless-concat
                            " " + t("Position") + ":" + "(" + content[1] + "," + content[2] + ")"
                          ) : (
                            <div></div>
                          )}
                        </li>
                      );
                    else if (valuation === "NEGATIVE")
                      return (
                        <li key={index3} className="no-bulletpoint">
                          {" "}
                          {numberTag(content[4])}<FaArrowAltCircleDown className="has-text-danger" /> &nbsp; {content[0]}
                          {content[1] !== 0 || content[2] !== 0 ? (
                            // eslint-disable-next-line no-useless-concat
                            " " + t("Position") + ":" + "(" + content[1] + "," + content[2] + ")"
                          ) : (
                            <div></div>
                          )}
                        </li>
                      );
                    else if (valuation === "NEUTRAL")
                      return (
                        <li key={index3} className="no-bulletpoint">
                          {" "}
                          {numberTag(content[4])}<FaArrowAltCircleRight className="has-text-warning" /> &nbsp; {content[0]}
                          {content[1] !== 0 || content[2] !== 0 ? (
                            // eslint-disable-next-line no-useless-concat
                            " " + t("Position") + ":" + "(" + content[1] + "," + content[2] + ")"
                          ) : (
                            <div></div>
                          )}
                        </li>
                      );
                    else
                      return (
                        <li key={index3} className="no-bulletpoint">
                          {" "}
                          {numberTag(content[4])}<FaCircle /> &nbsp; {content[0]}
                          {content[1] !== 0 || content[2] !== 0 ? (
                            // eslint-disable-next-line no-useless-concat
                            " " + t("Position") + ":" + "(" + content[1] + "," + content[2] + ")"
                          ) : (
                            <div></div>
                          )}
                        </li>
                      );
                  })}
                </div>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  const getCategoryItem = (category: any, index: number) => {
    return (
      <div key={index}>
        <h4 className="title is-6 mb-2 mt-3">{category}</h4>
        {getValuationItem(categoryMap[category], index)}
      </div>
    );
  };

  const getCategorycard = () => {
    if (Object.keys(categoryMap).length === 0) {
      return <p className="is-italic">{t("noListFeedback")}</p>;
    }
    return (
      <div>
        {Object.keys(categoryMap).map((category, index) => {
          return getCategoryItem(category, index);
        })}
      </div>
    );
  };

  let feedbackCard = (
    <div className="content">
      <div className="columns">
        <div className="column has-text-left">{getCategorycard()}</div>
      </div>
    </div>
  );

  let metatable = (
    <div>
      <div className="table-container">
        <table className="table is-striped is-narrow is-hoverable is-fullwidth">
          <thead className="is-italic">
            <tr>
              <td>{t("requested")}</td>
              <td>{t("finished")}</td>
              {/* <td>{t("comment")}</td> */}
              <td>{t("gradingServices")}</td>
              <td>{t("percentage")}</td>
              <th>{t("Score")}</th>
            </tr>
          </thead>
          <tbody>
            <tr key={assessment.id}>
              {/*} TODO: Date in GMT */}
              <td> {new Date(assessment.createdAt).toLocaleDateString(i18n.language, dateOptions)}</td>
              <td> {new Date(assessment.updatedAt).toLocaleDateString(i18n.language, dateOptions)}</td>
              {/* 
              <td>
                {assessment.comment ? <div>{assessment.comment}</div> : <div>{"no comment"}</div>}
              </td>
              */}
              <td>{assessment.gradings.length}</td>
              <td>
                {(
                  100 *
                  (parseFloat(
                    (Math.round(assessment.totalscore * 100 * parseFloat(assessment.maxTotalScore)) / 100).toFixed(2),
                  ) /
                    parseFloat(parseFloat(assessment.maxTotalScore).toFixed(2)))
                ).toFixed(2)}{" "}
                %
              </td>
              <th className="has-text-right">
                {parseFloat(
                  (Math.round(assessment.totalscore * 100 * parseFloat(assessment.maxTotalScore)) / 100).toFixed(2),
                )}{" "}
                / {parseFloat(parseFloat(assessment.maxTotalScore).toFixed(2))}
              </th>
            </tr>
          </tbody>
        </table>
        <table className="table is-striped is-narrow is-hoverable is-fullwidth">
          <thead className="is-italic">
            <tr>
              <td>{t("gradingService")}</td>
              <td>{t("result")}</td>
              <td>{t("resulttype")}</td>
              <td>{t("weight")}</td>
              <th className="has-text-right">{t("partialScore")}</th>
            </tr>
          </thead>
          <tbody>
            {assessment.gradings.map((grading: any) => {
              return getTableItemGrading(grading);
            })}
          </tbody>
        </table>
        <p className="is-size-7 has-text-grey">{t("scoreTablesExplanation")}</p>
        {assessment.comment !== null && assessment.comment !== "" && assessment.comment !== " " ? (
          <div>
            <i>
              {" "}
              <h4 className="title is-6 mb-2 mt-3">{t("comment")}</h4>
            </i>
            <i>{assessment.comment}</i>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );

  if (ohneBewertung) {
    return (
      <div className="section">
        <div className="columns is-centered">
          <div className="column is-two-thirds">
            <div className="notification is-warning is-light">
              <p className="has-text-weight-semibold">{t("noAssessmentTitle")}</p>
              <p className="mt-2">{t("noAssessmentText")}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="section">
      <div className="columns">
        <div className="column">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">
                {t("FeedbackForExercise")} »{submission_exercise.exercise ? submission_exercise.exercise.name : ""}«
              </p>
            </header>
            <div className="card-content">
              <div className="content" data-color-mode="light">
                <MDEditor.Markdown source={description} />
              </div>
              <div className="content" data-color-mode="light">
                <MDEditor.Markdown source={scenario} />
              </div>
              <div className="content">
                {modelId !== -1 && modelId !== undefined ? (
                  <ModelCardComponentMC
                    modelId={modelId.toString()}
                    submissionExerciseId={submissionExerciseId as string}
                  />
                ) : (
                  <div> </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">{t("Feedback")}</p>
            </header>
            <div className="card-content">
              <div className="content">
                <div className="columns">
                  <div className="column has-text-weight-light">{feedbackCard}</div>
                </div>
              </div>
              <div className="columns">
                <div className="column has-text-left"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card">
            <header className="card-header">
              <p className="card-header-title">{t("Assessment")}</p>
            </header>
            <div className="card-content">
              <div className="content">
                <div className="columns">
                  <div className="column has-text-weight-light">{metatable}</div>
                </div>
              </div>
            </div>
          </div>
         {/* check if feedForwardThreshold exists */}
         {feedForwardThreshold !== null ? (
          <div className="card mt-5">
            <header className="card-header">
              <p className="card-header-title">{t("feedForward")}</p>
            </header>
            <div className="card-content">
              {/* check if feedForwardThreshold exists */}
              {assessment.totalscore >= feedForwardThreshold ? (
                  /* totalscore >= feedForwardThreshold: show feedForwardPos */
                  <div className="columns">
                    <div className="column has-text-left">{feedForwardPos}</div>
                  </div>
                ) : (
                  /* totalscore < feedForwardThreshold: show feedForwardNeg */
                  <div className="columns">
                    <div className="column has-text-left">{feedForwardNeg}</div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div>
        <button className="button is-danger" onClick={() => back()}>
          {t("back")}
        </button>
      </div>
    </div>
  );
};
